import axios from "axios";

import { isInternalIP } from "./lib";

const baseHeaders = {
	Accept: "application/json",
	"Content-Type": "application/json",
	"X-TRP-Requested-With": "XMLHttpRequest"
};

export const getAuthStatus = async ({ appConfig }) => {
	try {
		const res = await axios.post(
			`${appConfig.clxUrl}/clx-tk/token-exchange/service/outbound`,
			null,
			{
				headers: {
					...baseHeaders,
					"Access-Control-Allow-Credentials": true,
					"X-Content-Type-Options": "nosniff",
					"X-Frame-Options": "SAMEORIGIN",
					"X-XSS-Protection": 1,
					"Strict-Transport-Security": "max-age=31536000; includeSubDomains"
				},
				withCredentials: true
			}
		);

		if (res.status === 200) {
			return res.data;
		} else {
			return { error: "bad response" };
		}
	} catch (err) {
		return { error: "error making call" };
	}
};

export const getInternalStatus = async ({ appConfig }) => {
	let isInternal = false;

	try {
		const res = await axios.get(`${appConfig.apiUrl}/cdpa-intake-api/health`, {
			headers: {
				...baseHeaders,
				apiKey: appConfig.apiKey
			}
		});

		if (res.status === 200) {
			if (
				res.headers &&
				typeof res.headers["x-forwarded-for"] === "string" &&
				isInternalIP(res.headers["x-forwarded-for"])
			) {
				isInternal = true;
			}

			return isInternal;
		} else {
			return isInternal;
		}
	} catch (err) {
		return isInternal;
	}
};

export const saveFormData = async ({ data, appConfig }) => {
	try {
		const res = await axios.post(
			`${appConfig.apiUrl}/cdpa-intake-api/v1/request`,
			data,
			{
				headers: {
					...baseHeaders,
					apikey: appConfig.apiKey
				}
			}
		);

		if (res.status === 200) {
			return res.data;
		} else {
			return {
				error: "There was an error saving the form.  Please try again."
			};
		}
	} catch (err) {
		return { error: "There was an error saving the form.  Please try again." };
	}
};
